import React, { useState, Children } from 'react';
import propTypes from 'prop-types';
import ErrorsList from 'components/ErrorsList';
import Switch from 'components/Switch';
import classNames from 'lib/classNames';
import { SideBarBadge } from './Sidebar';
import Button from './Button';

const FormControl = ({
	label,
	labelColor = 'text-gray-600',
	children,
	className = '',
	marginBottom = 'mb-6',
	info = null,
	error = null,
	showError = true,
	styles = {
		container: {},
		label: {},
	},
	withSwitch,
	childrenWidth = 'w-1/2',
	singleChildWidth = 'w-full',
	isSingleCol,
	beta,
	action,
	Footer
}) => {
	const isErrorArray = Array.isArray(error);
	const isString = (error) => typeof error === 'string';
	const hasErrors = (isErrorArray ? error.filter(isString).length : error) && !!showError;
	const getErrors = isErrorArray ? error.filter(isString) : error;
	return (
		<div
			className={classNames(className, {
				[marginBottom]: Children.count(children) === 1 || isSingleCol,
			})}
		>
			{!!label && (
				<div className={classNames('flex items-center mb-1', {
					"mb-3": Children.count(children) && withSwitch
				})}>
					<label
						className={classNames('block flex-1 flex-grow capitalize text-sm font-bold', labelColor, {
							error: !!hasErrors,
						})}
					>
						{label}
					</label>
					{!!withSwitch && <Switch BindToContext={withSwitch} />}
					{!withSwitch && beta && <span className={classNames('flex-center bg-orange-500 tracking-wider py-1 px-2 rounded-lg text-white text-xxs font-bold')} style={{ top: -2, right: -2 }}>Beta</span>}
					{!withSwitch && action && <Button type="link-danger" icon="trash" size="medium" onClick={action} style={{ top: -2, right: -2 }} />}
				</div>
			)}
			{!!info && (
				<p
					className={classNames('text-gray-500 text-xs italic mb-1', {
						error: !!hasErrors,
					})}
					dangerouslySetInnerHTML={{
						__html: info.replace('\n', '<br/>'),
					}}
				/>
			)}
			{Children.count(children) > 1 && !isSingleCol && (
				<div
					className={classNames('flex flex-wrap -mx-2', {
						'mb-2': !!hasErrors,
					})}
				>
					{Children.map(children, (child, i) => (
						<div className={classNames('px-2', childrenWidth, marginBottom)}>{child}</div>
					))}
				</div>
			)}
			{(Children.count(children) === 1 || isSingleCol) && (
				<div className={classNames(singleChildWidth)}>{children}</div>
			)}
			{!!Footer && <Footer />}
			{!!hasErrors && <ErrorsList {...{ error: getErrors, showFirstOnly: true }} style={{ marginTop: 10 }} />}
		</div>
	);
};

FormControl.propTypes = {
	label: propTypes.string,
};

FormControl.defaultProps = {
	info: false,
	style: {},
};
export default FormControl;
